import { useContext } from 'react';
import { isEmpty } from 'lodash';
import { useStore } from 'common/store';
import { Answer } from 'common/types/firm';
import { UseStoreValues } from 'common/types/store';
import { TaskContext } from 'context/TaskContext';
import { TaskContextType } from 'context/TaskContext/types';
import { StyledBox, StyledSubtitleTypography, StyledTypography } from './ProcessManagementRequestHeader.styles';
import { ProcessManagementRequestHeaderProps } from './types';
import CircularProgressWithLabel from '../../RequestDocuments/components/CircularProgressWithLabel';
import { getProgressOnRequiredTasks } from '../utils/getProgressOnRequiredTasks';

const ProcessManagementRequestHeader = ({
  title,
  subtitle,
  requestedTasksType,
}: ProcessManagementRequestHeaderProps) => {
  const { requestedFiles, requestedQuestions } = useContext(TaskContext) as TaskContextType;
  const [{ user }] = useStore() as unknown as UseStoreValues;

  const mappedUser = user
    ? {
      ...user,
      firms_permissions: user.firms_permissions?.map(firm => ({
        name: firm.name,
        slug: firm.slug,
        user_permission_set: [],
        role: 0,
        id: firm.id ?? 0,
      })),
    }
    : null;

  const progress = getProgressOnRequiredTasks({
    requestedTasksType,
    requestedFiles,
    requestedQuestions,
    user: mappedUser,
  });

  const questionsCompleted: number = requestedQuestions.filter(
    (q: { answers: Answer[]; answered: boolean }) => !isEmpty(q.answers) || q.answered
  ).length;
  const totalQuestions = requestedQuestions.length;
  const questionsSubtitle = (
    <>
      <span style={{ fontWeight: 700 }}>{subtitle}</span> {questionsCompleted}/{totalQuestions} questions completed
    </>
  );

  const documentsSubtitle = <span style={{ fontWeight: 700 }}>{subtitle}</span>;

  return (
    <StyledBox>
      <div>
        <StyledTypography>{title}</StyledTypography>
        <StyledSubtitleTypography>
          {requestedTasksType === 'questions' ? questionsSubtitle : documentsSubtitle}
        </StyledSubtitleTypography>
      </div>
      <CircularProgressWithLabel progress={progress} />
    </StyledBox>
  );
};

export default ProcessManagementRequestHeader;
